import { SERVER_URI, TEST_URI, SERVER_URI1 } from '../Constant/server';
import { apiGet, apiPost, apiPost1, apiPut1, apiPut } from '../utils/axios';

const ADD_ACTIVITY_PRODUCT = SERVER_URI + '/add-activity-product-type';
const GET_ACTIVITY_TYPE_LIST = SERVER_URI + '/get-activity-product-type';
const UPDATE_ACTIVITY_TYPE = SERVER_URI + '/update-activity-product-type/';
const ADD_ACTIVITY = SERVER_URI + '/add-activity-product';
const GET_ACTIVITY_LIST = SERVER_URI + '/get-activity-product';
const UPDATE_ACTIVITY = SERVER_URI + '/update-activity-product/';
const UPDATE_ACTIVITY_STATUS = SERVER_URI + '/change-status-activity-product/';
const CHANGE_ACTIVITY_TYPE_STATUS = SERVER_URI + '/change-status-activity-product-type/';

export default {
    addActivityProduct: async function (paylaod) {
        return apiPost1(ADD_ACTIVITY_PRODUCT, paylaod);
    },
    getActivityTypeList: async function (payload) {
        return apiPost(GET_ACTIVITY_TYPE_LIST, payload);
    },
    updateActivityType: async function (id, payload) {
        return apiPut1(UPDATE_ACTIVITY_TYPE + id, payload)
    },
    changeActivityTypeStatus: async function (id) {
        return apiGet(CHANGE_ACTIVITY_TYPE_STATUS + id);

    },
    addActivity: async function (paylaod) {
        return apiPost(ADD_ACTIVITY, paylaod);
    },
    getActivityList: async function (payload) {
        return apiPost(GET_ACTIVITY_LIST, payload);
    },
    updateActivity: async function (id, payload) {
        return apiPut(UPDATE_ACTIVITY + id, payload)
    },
    updateActivityStatus: async function (id) {
        return apiGet(UPDATE_ACTIVITY_STATUS + id)
    },


}